module.exports = __webpack_public_path__ + "static/portfolio-engagedtexting-20228f2e269dce0bb5b96baf9bfd7b20.jpg";